import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      $currentApp: 'application/currentApplication',
    }),
    appLogin() {
      if (!this.$currentApp) return

      return this.$currentApp.domain
    },
  },
}
